export default __webpack_public_path__ + "static/Live_Cams_04-e7aee5bd65b3261f6ae2b59aa4b7009a.webp";